import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "./Logo";
import ThemeToggle from "./ThemeToggle";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

const LINKS = [
  { to: "/features", label: "Özellikler" },
  { to: "/developers", label: "Geliştiriciler" },
  { to: "/docs", label: "Dokümantasyon" },
  { to: "/security", label: "Güvenlik" },
  { to: "/about", label: "Hakkımızda" },
];

export default function PublicNav() {
  const [open, setOpen] = useState(false);
  const loc = useLocation();
  const { user } = useAuth();
  const dashHref = user && user.role === "admin" ? "/admin" : "/dashboard";

  return (
    <header className="sticky top-0 z-50 w-full border-b border-border glass bg-background/70">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6">
        <Logo />
        <nav className="hidden lg:flex items-center gap-1">
          {LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.to.slice(1)}`}
              className={`rounded-full px-3.5 py-2 text-sm font-medium transition-colors ${
                loc.pathname === l.to ? "text-primary bg-accent" : "text-muted-foreground hover:text-foreground"
              }`}
            >
              {l.label}
            </Link>
          ))}
        </nav>
        <div className="hidden lg:flex items-center gap-2">
          <ThemeToggle />
          {user ? (
            <Link to={dashHref}>
              <Button data-testid="nav-dashboard-btn" className="rounded-full">Panele Git</Button>
            </Link>
          ) : (
            <>
              <Link to="/login">
                <Button variant="ghost" data-testid="nav-login-btn" className="rounded-full">Giriş Yap</Button>
              </Link>
              <Link to="/register">
                <Button data-testid="nav-register-btn" className="rounded-full">Hemen Başla</Button>
              </Link>
            </>
          )}
        </div>
        <div className="flex items-center gap-2 lg:hidden">
          <ThemeToggle />
          <button data-testid="mobile-menu-btn" onClick={() => setOpen((o) => !o)} className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-border">
            {open ? <X size={18} strokeWidth={1.5} /> : <Menu size={18} strokeWidth={1.5} />}
          </button>
        </div>
      </div>
      {open && (
        <div className="lg:hidden border-t border-border bg-background px-4 py-4 space-y-1">
          {LINKS.map((l) => (
            <Link key={l.to} to={l.to} onClick={() => setOpen(false)} className="block rounded-lg px-3 py-2.5 text-sm font-medium text-muted-foreground hover:bg-accent hover:text-foreground">
              {l.label}
            </Link>
          ))}
          <div className="flex gap-2 pt-2">
            {user ? (
              <Link to={dashHref} className="flex-1" onClick={() => setOpen(false)}><Button className="w-full rounded-full">Panele Git</Button></Link>
            ) : (
              <>
                <Link to="/login" className="flex-1" onClick={() => setOpen(false)}><Button variant="outline" className="w-full rounded-full">Giriş Yap</Button></Link>
                <Link to="/register" className="flex-1" onClick={() => setOpen(false)}><Button className="w-full rounded-full">Hemen Başla</Button></Link>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
